// extracted by mini-css-extract-plugin
export default {"error":"Input_error__zrQ9j","textError":"Input_textError__qy6qz"};